import { cn } from "../../helpers"

export type SkeletonPageVariant = "default" | "narrow"

const wrapper = (variant: SkeletonPageVariant = "default") =>
  cn(
    "flex w-full flex-col items-center gap-8 lg:gap-8 mx-auto",
    variant === "narrow" ? "max-w-[36.750rem]" : "max-w-[41.25rem] px-3"
  )
const header = cn("flex w-full flex-col items-center gap-6")
const avatar = cn("h-16 w-16 rounded-full")
const headerBlock = cn("flex w-full flex-col items-center gap-1")
const line1 = cn("h-6 w-full")
const line2 = cn("h-6 w-full max-w-[16rem]")
const line3 = cn("h-5 w-32")
const line4 = cn("h-12 w-full")
const line5 = cn("h-[4.5rem] w-full")
const line6 = cn("h-14 w-full")
const content = cn("flex w-full flex-col gap-2")

export { wrapper, header, avatar, headerBlock, line1, line2, content, line3, line4, line5, line6 }
